import script from "./AgentVoiceFields.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentVoiceFields.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import InputArea from "@/components/neue/InputArea.vue";
import SelectInput from "@/components/neue/SelectInput.vue";
import SettingsSection from "@/components/neue/SettingsSection.vue";
script.components = Object.assign({}, { InputArea, SelectInput, SettingsSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { InputArea, SelectInput, SettingsSection }, script.__o.components);}